import * as React from "react";
import {CSSProperties, ReactChild, ReactElement} from "react";
import {duration} from "moment";
import {Spring, SpringConfig} from "shared/controls/animation/react-spring/renderprops";


export class SwitchContainer extends React.Component<SwitchContainerProps, SwitchContainerState> {
    public index:number=0;
    static defaultProps: Partial<SwitchContainerProps> = {

    };
    public componentContainer1:HTMLElement;
    public componentContainer2:HTMLElement;

    constructor(props: SwitchContainerProps, context?: any) {
        super(props, context);
        this.state = {
            componentToDisplay1:this.props.children as any,
            componentToDisplay2:null,
            currentComponentToShow:1,
            status:'showed'
        };
    }


    componentWillReceiveProps(nextProps: Readonly<SwitchContainerProps>, nextContext: any): void {
        let nextChildren:any=(nextProps as any).children;
        let currentChildren:any=this.props.children;

        if(nextChildren==false)
            nextChildren=null;
        if(currentChildren==false)
            currentChildren=null;
        if(nextChildren==null||currentChildren==null)
        {
            //if there was a change from null to not null or viceversa execute animation
            if(nextChildren!=currentChildren)
                this.SwitchComponent((nextProps as any).children);
            return;
        }

        nextChildren=React.Children.only(nextChildren);
        currentChildren=React.Children.only(currentChildren);

        if(typeof nextChildren.key!='undefined'&&typeof currentChildren.key!='undefined')
            if(nextChildren.key==currentChildren.key) {
                let state:Partial<SwitchContainerState>={};
                if(this.state.currentComponentToShow==1)
                    this.setState({componentToDisplay1:nextChildren});
                else
                    this.setState({componentToDisplay2:nextChildren});

                return;

            }

        if(this.props.children==(nextProps as any).children)
        {
            return;
        }

        this.SwitchComponent((nextProps as any).children);
    }

    public render() {
        let previousComponentStyles1:any={};
        let newComponentStyles1:any={opacity:1};
        let additionalStyles1:any={};

        let previousComponentStyles2:any={};
        let newComponentStyles2:any={opacity:1};
        let additionalStyles2:any={};


        let beforePreviousComponentStyles:any=previousComponentStyles1;
        let beforeComponentStyles:any=newComponentStyles1;
        let beforeAdditionalStyles:any=additionalStyles1;
        let afterPreviousComponentStyles:any=previousComponentStyles2;
        let afterComponentStyles:any=newComponentStyles2;
        let afterAdditionalStyles:any=additionalStyles2;
        let afterComponentContainer:HTMLElement=this.componentContainer2;
        if(this.state.currentComponentToShow==2)
        {
            beforePreviousComponentStyles=previousComponentStyles2;
            beforeComponentStyles=newComponentStyles2;
            beforeAdditionalStyles=additionalStyles2;
            afterPreviousComponentStyles=previousComponentStyles1;
            afterComponentStyles=newComponentStyles1;
            afterAdditionalStyles=additionalStyles1;

            afterComponentContainer=this.componentContainer1;

        }

        let isImmediate=false;
        switch(this.state.status)
        {
            case "showed":
                isImmediate=true;
                beforeComponentStyles.height='auto';
                afterAdditionalStyles.display='none';
                break;
            case "showing":
                afterComponentStyles.opacity=1;
                beforeComponentStyles.opacity=0;
                beforeComponentStyles.height=afterComponentContainer!=null?afterComponentContainer.getBoundingClientRect().height:0;
                afterComponentStyles.height=afterComponentContainer!=null?afterComponentContainer.getBoundingClientRect().height:0;
                beforeComponentStyles.overflow='hidden';

                afterAdditionalStyles.position='absolute';
                afterAdditionalStyles.top=0;

                break;
          /*  case "hiding":
                newStatus.opacity=0;
                newStatus.height=this.state.nextComponentToDisplay==null?0:this.nextComponentContainer.offsetHeight;
                additionallStyles.overflow='hidden';
                if(this.container.offsetHeight==0)
                    isImmediate=true;
                break;*/
            case "switching":
                isImmediate=true;
                afterComponentStyles.opacity=0;
                afterAdditionalStyles.top=0;
                afterAdditionalStyles.position='absolute';
                afterAdditionalStyles.opacity=0;
                afterAdditionalStyles.height='auto';
                afterAdditionalStyles.display='block';




                break;

        }



        return (
            <div className={this.props.className} style={this.props.style}>
                <div style={{position:'relative'}}>
                    <Spring  config={{precision:.09}}   from={previousComponentStyles1} to={newComponentStyles1} immediate={isImmediate}  onRest={()=>{this.state.currentComponentToShow==1&& this.AnimationEnded()}}>
                        {styles=>{
                            return (
                                <div ref={e=>{this.componentContainer1=e==null?null:e}} style={{...styles,...additionalStyles1,width:'100%'}}>
                                        {this.state.componentToDisplay1}
                                </div>
                            )
                        }}

                    </Spring>
                    <Spring config={{precision:.09}}    immediate={isImmediate} from={previousComponentStyles2} to={newComponentStyles2} onRest={()=>{this.state.currentComponentToShow==2&&this.AnimationEnded()}}>
                        {styles=>{return(
                            <div ref={e=>{this.componentContainer2=e}} style={{...styles,...additionalStyles2,width:'100%'}} className={'switchcontainer2'}>
                                {this.state.componentToDisplay2!=null&&this.state.componentToDisplay2}
                            </div>
                        )}}
                    </Spring>
                </div>
            </div>
        )
    }

    private SwitchComponent(children: any) {

        let state:Partial<SwitchContainerState>={};
        if(this.state.currentComponentToShow==1) {
            state.componentToDisplay2 = children;
            state.componentToDisplay1=null;
        }
        else {
            state.componentToDisplay1 = children;
            state.componentToDisplay2=null;
        }

        state.status='switching';



        this.setState((state as any),()=>{
           this.setState({status:"showing"})
        });
    }

    private AnimationEnded() {
        switch(this.state.status)
        {
            case "showing":
                this.setState({status:'showed',currentComponentToShow:this.state.currentComponentToShow==1?2:1});
        }
    }
}




//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface SwitchContainerProps {
    config?:SpringConfig;
    style?:CSSProperties;
    className?:string;
}

interface SwitchContainerState {
    componentToDisplay1:ReactElement<any>;
    componentToDisplay2:ReactElement<any>;
    currentComponentToShow:number;
    status:'showing'|'showed'|'switching'

}

//#endregion "My Region"